// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { UserDetailsState } from './user-details.interfaces';
import { UserDetailsActions, UserDetailsActionTypes } from './user-details.actions';
import { LoadingStatus } from '@app/core';

export function userDetailsReducer(state: UserDetailsState = {}, action: UserDetailsActions) {
  switch (action.type) {
    case UserDetailsActionTypes.SELECT_USER:
      return {
        ...state,
        [action.payload.username]: {
          details: {
            ...getDetails(state, action.payload.username),
            data: {
              ...getData(state, action.payload.username),
              user: action.payload
            }
          }
        }
      };
      case UserDetailsActionTypes.USER_DETAILS_LOAD_COMPLETE:
      return action.payload.username
        ? {
            ...state,
            [action.payload.username]: {
              details: {
                data: {
                  user: action.payload
                },
                status: LoadingStatus.LOAD_COMPLETE
              }
            }
          }
        : state;

    case UserDetailsActionTypes.USER_DETAILS_LOAD_FAILED:
      return {
        ...state,
        [action.payload]: {
          details: {
            ...getDetails(state, action.payload),
            status: LoadingStatus.LOAD_FAILED
          }
        }
      };
    default:
      return state;
  }
}

function getDetails(state: any, key: any) {
  if (!state) {
    return {};
  }

  if (!state[key]) {
    return {};
  }

  return state[key].details || {};
}

function getData(state: any, key: any) {
  return getDetails(state, key).data || {};
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/user-details/user-details.reducer.ts